import { render, staticRenderFns } from "./EditMateriale.vue?vue&type=template&id=2da67263&scoped=true"
import script from "./EditMateriale.vue?vue&type=script&lang=js"
export * from "./EditMateriale.vue?vue&type=script&lang=js"
import style0 from "./EditMateriale.vue?vue&type=style&index=0&id=2da67263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da67263",
  null
  
)

export default component.exports